export function createRangeRemapper([inMin, inMax]: [number, number], [outMin, outMax]: [number, number] = [0, 1]) {
    return (value: number) => {
        // if you need an integer value use Math.floor or Math.ceil here
        return ((value - inMin) / (inMax - inMin)) * (outMax - outMin) + outMin;
    };
}
